import { TrafficControl } from "../traffic_control";
import moment from "moment";
import { convertToMoment } from "../helpers/date";
import { reduce, isArray, has } from "lodash";

const debugProcess = process => {
  if (window.debugProcess) {
    console.log("process=", process);
  }
  return process;
};

const clearFileDataFromAnswers = (currentQuestion, answers) => {
  let updatedAnswers = reduce(
    answers,
    (acc, answer, questionId) => {
      let updatedAnswer;

      if (currentQuestion.id == questionId) {
        updatedAnswer = answer;
      } else {
        if (
          isArray(answer) &&
          has(answer[0], "name") &&
          has(answer[0], "data") &&
          has(answer[0], "type")
        ) {
          updatedAnswer = [];
        } else {
          updatedAnswer = answer;
        }
      }

      acc[questionId] = updatedAnswer;
      return acc;
    },
    {}
  );

  return updatedAnswers;
};

const getCurrentPage = state => {
  return _.find(Object.values(state.pages || []), [
    "attributes.sequence",
    state.page
  ]);
};

const getCurrentQuestion = state => {
  let currentPage = getCurrentPage(state);
  if (currentPage == undefined) return null;
  return _.find(Object.values(currentPage.attributes.questions), [
    "sequence",
    state.question
  ]);
};

const questionHasRoutingRules = question => {
  if (_.isEmpty(question) && !_.isObject(question)) return false;
  return (_.get(question, "routingRules", []) || []).length > 0;
};

const questionHasRoutingLogic = question => {
  if (_.isEmpty(question) && !_.isObject(question)) return false;
  if (questionHasRoutingRules(question)) {
    return true;
  }
  let kind = _.get(question, "kind", "");
  if (kind == "multichoice" || kind == "casegrid") {
    return true;
  }

  return false;
};

const hasQuestionSkipTo = (currentPage, question, answers) => {
  let questionSkip = false;
  // check for skip logic
  _.forEach(currentPage.attributes.questions[question].fields, field => {
    if (
      _.has(field, "skipTo") &&
      answers[currentPage.attributes.questions[question].id] === field.choice
    ) {
      questionSkip = field.skipTo;
    }
  });
  return questionSkip;
};

const hasPageSkipTo = currentPage => {
  let pageSkip = false;
  if (
    _.has(currentPage.attributes.logic, "skipTo") &&
    currentPage.attributes.logic.skipTo
  ) {
    pageSkip = currentPage.attributes.logic.skipTo;
  }

  return pageSkip;
};

const getAnswer = (answers, question) => {
  return {
    choice: answers[question.id]
  };
};

const getQuestionMetaForCheckboxes = process => {
  let question = process.currentQuestion;
  let answers = process.state.answers;
  let answer = getAnswer(answers, question);
  return {
    checkedCount: (answer.choice || []).length,
    value: answer.choice
  };
};

const getQuestionMetaForDate = process => {
  let question = process.currentQuestion;
  let answers = process.state.answers;
  let answer = getAnswer(answers, question);
  let now = moment();
  //try and strip the time and time zone data
  let date = convertToMoment(answer.choice);
  return {
    date: date,
    age: now.diff(date, "years")
  };
};

const getQuestionMetaForMultitext = process => {
  let question = process.currentQuestion;
  let answers = process.state.answers;
  let answer = getAnswer(answers, question);
  let value = _.reduce(
    answer.choice,
    (collection, choice) => {
      collection.push(choice.value);
      return collection;
    },
    []
  );
  return {
    value: value,
    valueAsString: value.join(" ")
  };
};

const getQuestionMetaDefault = process => {
  let question = process.currentQuestion;
  let answers = process.state.answers;
  let answer = getAnswer(answers, question);
  let value = answer.choice;
  return {
    value: value
  };
};

const questionMetaMapper = question => {
  const questionKindMap = {
    checkbox: getQuestionMetaForCheckboxes,
    date: getQuestionMetaForDate,
    multitext: getQuestionMetaForMultitext
  };
  return questionKindMap[question.kind] || getQuestionMetaDefault;
};

const onQuestionWithRoutingRules = process => {
  if (process.decided == true) return process;
  let routingRules = process.currentQuestion.routingRules;
  if (!_.isEmpty(routingRules)) {
    let questionMeta = questionMetaMapper(process.currentQuestion)(process);
    let matched = TrafficControl.evalRules(questionMeta, routingRules);
    if (matched) {
      process.questionSkip = matched.skipTo;
    }
  }
  return process;
};

const onQuestionShowSummary = process => {
  if (process.decided == true) return process;
  if (process.questionSkip == "summary") {
    process.showSummary = true;
    process.decided = true;
  }
  return process;
};

const onQuestionSkipToPage = process => {
  if (process.decided == true) return process;
  let skipToPage = process.state.pages[process.questionSkip];
  if (skipToPage) {
    process.page = skipToPage.attributes.sequence;
    process.question = 0;
    process.decided = true;
  }
  return process;
};

const onQuestionSkipToAlternateEnding = process => {
  if (process.decided == true) return process;
  let skipToAlternateEnding =
    process.state.alternateEndings[process.questionSkip];
  if (skipToAlternateEnding) {
    process.showSummary = true;
    process.alternateEnding = process.questionSkip;
    process.decided = true;
  }
  return process;
};

const onNextQuestion = process => {
  if (process.decided == true) return process;
  if (
    process.state.question <
    process.currentPage.attributes.questions.length - 1
  ) {
    process.question += 1;
    process.decided = true;
  }
  return process;
};

const onLastQuestionOnPage = process => {
  if (process.decided == true) return process;

  if (process.pageSkip) {
    if (process.pageSkip === "summary") {
      process.showSummary = true;
    } else if (process.state.pages[process.pageSkip]) {
      process.page = process.state.pages[process.pageSkip].attributes.sequence;
      process.question = 0;
    } else if (process.state.alternateEndings[process.pageSkip]) {
      process.alternateEnding = process.pageSkip;
      process.showSummary = true;
    } else {
      if (process.onLastPage) {
        process.showSummary = true;
      } else {
        process.page += 1;
        process.question = 0;
      }
    }
  } else {
    if (process.onLastPage) {
      process.showSummary = true;
    } else {
      process.page += 1;
      process.question = 0;
    }
  }
  return process;
};

const processComplete = process => {
  if (process.showSummary === true) {
    //no matter what if we reach the summary page we should show 100% done
    process.completed = 100;
  } else {
    process.completed = calcCompleted(
      process.page,
      process.question,
      process.state.pages
    );
  }

  return process;
};

const calcCompleted = (page, question, pages) => {
  let totalQuestions = 0;
  let questionsLeft = 0;

  _.forEach(pages, currentPage => {
    totalQuestions += currentPage.attributes.questions.length;
    if (currentPage.attributes.sequence >= page) {
      _.forEach(currentPage.attributes.questions, currentQuestion => {
        if (
          (currentPage.attributes.sequence === page &&
            currentQuestion.sequence >= question) ||
          currentPage.attributes.sequence > page
        ) {
          questionsLeft += 1;
        }
      });
    }
  });
  let completed = ((totalQuestions - questionsLeft) / totalQuestions) * 100;
  return completed;
};

export {
  hasQuestionSkipTo,
  hasPageSkipTo,
  onQuestionShowSummary,
  onQuestionSkipToPage,
  onQuestionSkipToAlternateEnding,
  onNextQuestion,
  onLastQuestionOnPage,
  processComplete,
  calcCompleted,
  getCurrentPage,
  getCurrentQuestion,
  onQuestionWithRoutingRules,
  debugProcess,
  questionHasRoutingRules,
  questionHasRoutingLogic,
  getAnswer,
  clearFileDataFromAnswers
};
